import React, { useContext } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { Link } from 'react-router-dom';

// School-specific dashboard view
const SchoolDashboard = () => {
    const { students, teachers, courses, assessments } = useContext(SchoolContext);
    const studentTeacherRatio = teachers.length > 0 ? (students.length / teachers.length).toFixed(1) : 0;

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Dashboard Overview</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <Card title="Total Students"><p className="text-4xl font-bold text-primary">{students.length}</p></Card>
                <Card title="Total Teachers"><p className="text-4xl font-bold text-primary">{teachers.length}</p></Card>
                <Card title="Courses Offered"><p className="text-4xl font-bold text-primary">{courses.length}</p></Card>
                <Card title="Student-Teacher Ratio"><p className="text-4xl font-bold text-primary">{studentTeacherRatio}:1</p></Card>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-1">
                    <Card title="Quick Actions">
                        <div className="flex flex-col space-y-2">
                            <Link to="/students"><Button>Add Student</Button></Link>
                            <Link to="/teachers"><Button>Add Teacher</Button></Link>
                            <Link to="/courses"><Button>Add Course</Button></Link>
                        </div>
                    </Card>
                </div>
                <div className="lg:col-span-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <Card title="Upcoming Assessments">
                            <ul className="space-y-3">
                                {assessments.map(assessment => <li key={assessment.id} className="p-2 bg-gray-50 rounded-md">{assessment.name}</li>)}
                            </ul>
                        </Card>
                        <Card title="Course Overview">
                            <ul className="space-y-3">
                                {courses.map(course => <li key={course.id} className="p-2 bg-gray-50 rounded-md flex justify-between"><span>{course.name}</span><span className="text-gray-500">{course.teacher}</span></li>)}
                            </ul>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Super Admin dashboard view
const SuperAdminDashboardView = () => {
    const metrics = { totalSchools: 15, totalUsers: 2500, systemFeatures: 8 };
    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Super Admin Dashboard</h1>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <Card title="Total Schools Created"><p className="text-4xl font-bold text-red-600">{metrics.totalSchools}</p></Card>
                <Card title="Total System Users"><p className="text-4xl font-bold text-red-600">{metrics.totalUsers}</p></Card>
                <Card title="Total System Features"><p className="text-4xl font-bold text-red-600">{metrics.systemFeatures}</p></Card>
            </div>
        </div>
    );
};

const Dashboard = () => {
    const { user } = useContext(SchoolContext);
    
    // Render the correct dashboard based on the user's role
    if (user.role === 'SuperAdmin') {
        return <SuperAdminDashboardView />;
    }
    
    return <SchoolDashboard />;
};

export default Dashboard;
